import { DeliveryState } from "../../../enums/orders";
import { DeliveryBatchState, OrderDeliveryTaskState } from "../../../enums/tasks";


export const AWAITING_COLLECTION = DeliveryBatchState.ASSIGNED as string
export const PENDING = OrderDeliveryTaskState.OUT_FOR_DELIVERY as string
export const IN_PROGRESS = `${OrderDeliveryTaskState.IN_PROGRESS},${OrderDeliveryTaskState.AWAITING_RETURN}`
export const FINISHED = `${OrderDeliveryTaskState.COMPLETED},${OrderDeliveryTaskState.FAILED}`
export const ALL = `${OrderDeliveryTaskState.OUT_FOR_DELIVERY},${OrderDeliveryTaskState.IN_PROGRESS},${OrderDeliveryTaskState.AWAITING_RETURN},${OrderDeliveryTaskState.COMPLETED},${OrderDeliveryTaskState.FAILED}`


export type TASK_STATE_CATEGORY =
    | DeliveryBatchState.ASSIGNED
    | DeliveryBatchState.OUT_FOR_DELIVERY
    | `${OrderDeliveryTaskState.IN_PROGRESS},${OrderDeliveryTaskState.AWAITING_RETURN}`
    | `${OrderDeliveryTaskState.COMPLETED},${OrderDeliveryTaskState.FAILED}`
    | `${OrderDeliveryTaskState.OUT_FOR_DELIVERY},${OrderDeliveryTaskState.IN_PROGRESS},${OrderDeliveryTaskState.AWAITING_RETURN},${OrderDeliveryTaskState.COMPLETED},${OrderDeliveryTaskState.FAILED}`
